"use client";
import React, { useEffect, useState } from "react";
import { FormikValues, useFormik } from "formik";
import GetQuoteForm from "./GetQuoteForm";
import { GetQuoteFormValidation } from "../components/common/form/validationSchema";
import { Contact } from "@/lib/http";
import Swal from "sweetalert2";

const GetQuote = ({ setIsModalOpen = (close: boolean) => {} }) => {
  const [currentPage, setCurrentPage] = useState("");

  useEffect(() => {
    if (typeof window !== "undefined") {
      setCurrentPage(window.location.href);
    }
  }, []);
  const formik = useFormik({
    initialValues: {
      Name: "",
      EmailID: "",
      PhoneNo: "",
      Message: "",
      SourceUrl: currentPage,
    },
    enableReinitialize: true,
    validationSchema: GetQuoteFormValidation,
    onSubmit: async (values, { resetForm }) => {
      try {
        const res = await Contact.api("post", {
          data: { ...values, Type: "Enquiry" },
        });
        if (res?.status === 200) {
          Swal.fire({
            title: "Quote successfully submitted",
            text: "Form submitted successfully",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            setIsModalOpen(false);
          });
          resetForm();
        }
      } catch (err) {
        console.error(err);
        Swal.fire({
          title: "Error",
          text: "Invalid!",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    },
    validateOnChange: false,
    validateOnBlur: true,
  });
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        formik.validateForm().then((errors) => {
          if (Object.keys(errors).length === 0) {
            formik.handleSubmit();
          }
        });
      }}
      className="space-y-4"
    >
      <h2 className="text-primaryColor text-xl font-semibold text-white">
        GET A QUOTE
      </h2>
      <GetQuoteForm {...formik} />
      <button
        type="submit"
        className="px-4 border font-semibold py-2 w-full bg-primaryColor text-white rounded"
      >
        SUBMIT
      </button>
    </form>
  );
};

export default GetQuote;
